/**
 * Quality Control Lesson
 * Skill Area: Communication
 * Verify AI output with the 3-Check Scan
 */

import type { LessonDefinition } from '../types';
import { QUALITY_CONTROL_AI_PROMPT, QUALITY_CONTROL_CONTEXT_SCENARIOS } from '../prompts/quality-control.prompt';

export const qualityControl: LessonDefinition = {
  id: 'quality-control',
  title: 'Quality Control',
  displayTitle: 'Verify AI Output with the 3-Check Scan',
  subTitle: 'Verify AI output maintains authenticity',
  persona: 'Lyra',
  skillArea: 'Communication',
  topicId: 'communication-quality',
  topicTitle: 'Communication Quality & Voice',
  topicDescription: 'Verify outputs, keep your voice authentic, and build reusable comms systems.',
  format: 'guided_chat',
  difficulty: 'Beginner',
  estimatedMinutes: 7,
  tags: ['quality', 'verification', 'authenticity'],
  dailyEligible: true,
  releasedAt: '2025-01-15T00:00:00.000Z',
  route: '/micro/quality-control',
  storyBeat: 'Ensure AI output maintains your authentic voice and credibility.',
  introPrompt: "Errors aren't just typos; they break trust. I'll explain the 3 checks, show you a comparison, and help you verify your draft.",
  steps: [
    "Identify your biggest quality concern",
    'See a "Generic vs. Quality-Checked" comparison',
    'Run the 3-Check Scan on your draft'
  ],
  promptGuidance: 'Choose a risk below or type your own.',
  contextScenarios: QUALITY_CONTROL_CONTEXT_SCENARIOS,
  aiPrompt: QUALITY_CONTROL_AI_PROMPT,
  inputPlaceholder: "Type 'Inaccurate Facts' or your own concern...",
  quickPrompts: [
    'Inaccurate Facts',
    'Generic Voice',
    'Missing Context'
  ]
};
